import { Query } from '../interfaces';

export const combineFilter = (filter: Query): string => {
    return encodeURI(
        Object.keys(filter)
            .filter((key) => filter[key] !== '')
            .map((key) => `${key}=${filter[key]}`)
            .join(','),
    );
};

export const combineFilterWithOp = (filter: Query): string => {
    return Object.keys(filter)
        .filter((key) => !!filter[key].value)
        .map((key) => {
            let propName = !!filter[key].keyOverride ? filter[key].keyOverride : key;
            let op = !!filter[key].operator ? filter[key].operator : '=';
            return `${propName}${op}${filter[key].value}`;
        })
        .join(',');
};

export const combineFilterMany = (filter: Query): string => {
    return Object.entries(filter)
        .map(([key, values]) => {
            if (!Array.isArray(values) || values.length === 0) {
                return '';
            }

            const formattedValues = values.map((value) => `${key}=${value}`).join('|');

            return values.length === 1 ? `(${formattedValues})` : `(${formattedValues})`;
        })
        .filter(Boolean)
        .join(',');
};

export const combineFieldsFilter = (filter: Query): string => {
    const groupedByValue = Object.entries(filter).reduce(
        (acc, [key, { value }]) => {
            if (!value) return acc;

            if (acc[value]) {
                acc[value].push(key);
            } else {
                acc[value] = [key];
            }

            return acc;
        },
        {} as Record<string, string[]>,
    );

    return Object.entries(groupedByValue)
        .map(([value, keys]) => keys.map((key) => `${key}${filter[key].operator || '='}${value.trim()}`).join('|'))
        .join(',');
};

export const joinFiltersWithComma = (...strings: string[]): string => {
    return strings.filter(Boolean).join(', ');
};
